<div id="footerfilter">
  <app-breadcrumb></app-breadcrumb>
</div>
    <div
      class="px-3"
      *ngIf="successMessage != null"
      class="alert alert-success alert-dismissible fade show p-2 ms-4 me-4"
      role="alert"
    >
      <button
        type="button"
        class="btn-close"
        (click)="close()"
        data-bs-dismiss="alert"
        aria-label="close"
      ></button>
      <strong>{{ successMessage }}</strong>
    </div>
    <div
      class="px-3"
      *ngIf="errorMessage != null"
      class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
      role="alert"
    >
      <button
        type="button"
        class="btn-close"
        (click)="close()"
        data-bs-dismiss="alert"
        aria-label="close"
      ></button>
      <strong>{{ errorMessage }}</strong>
    </div>
  
    <!-- <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
      </app-notification-message> -->
    <div id="headerfilter">
    <h2 class="roboto-medium ms-4">AET Imports</h2>
  
    <div class="d-flex justify-content-left ms-4 me-3 header">
      <div class="d-flex justify-content-left align-items-center me-5">
        <label for="step">Import Type</label>
        <select name="event-resolutions" id="importdropdown" class="ms-3 roboto">
          <option value="Events and Resolutions">Events and Resolutions</option>
        </select>
      </div>
      <div class="d-flex justify-content-between align-items-center ms-2 me-5">
        <label for="choose-file">File</label>
        <app-file-upload
          class="ms-3"
          (updateEvent)="onUpdateEvent($event)"
        ></app-file-upload>
      </div>
      <div class="d-flex justify-content-between align-items-center ms-2">
        <!-- <button class="import-button aet-btn-table" (click)="validateFile()">
          VALIDATE
        </button> -->
        <button class="import-button aet-btn-table" (click)="newvalidateFile()">
          VALIDATE
        </button>
        <!-- <button class="import-button aet-btn-table" (click)="importFile()">
          IMPORT
        </button> -->
        <button class="import-button aet-btn-table" (click)="newimportFile()">
          IMPORT
        </button>
        <button
          class="import-button aet-btn-table import-template-button"
          (click)="downloadTemp()"
        >
          GET IMPORT TEMPLATE
        </button>
      </div>
    </div>
    </div>
  
    <!-- <h4 class="ftpheader ms-4">AET FTP file import</h4> -->


<div class="import">
  
    <mat-accordion>
      <mat-expansion-panel #panel class="mat-elevation-z0">
        <mat-expansion-panel-header class="header-container">
          <mat-panel-title> AET FTP file import </mat-panel-title>
          <mat-panel-description class="bardesc"> </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="grid-agg px-4"  id="LIOS-grid">
          <ag-grid-angular style="min-height:400px"
            class="ag-theme-balham grid-items importftp"
            (gridReady)="onGridReady($event)"
            [columnDefs]="columnDefs"
            (window:resize)="sizeToFit()"
            [rowHeight]="rowHeight"
            [animateRows]="true"
            [defaultColDef]="defaultColDef"
            [icons]="icons"
            [suppressCellFocus]="true"
            [suppressHorizontalScroll]="false"
            [pagination]="true"
            [rowData]="displayRowData"
            [paginationPageSize]="paginationPageSize"
            [suppressPaginationPanel]="true"
            (paginationChanged)="onPaginationChanged()"
            [headerHeight]="40"
            [floatingFiltersHeight]="40"
            [rowClassRules]="rowClassRules"
            (modelUpdated)="onModelUpdated()" [theme]="'legacy'"
          ></ag-grid-angular>
  
          <div
            class="
              d-flex
              pagination
              px-2
              align-items-center
              justify-content-between
            "
            id="paginationfooter"
          >
            <div>
              <div>
                <label class="page-drpdwn-label me-2">Records/Page: </label>
                <select
                  (change)="onPageSizeChanged($event)"
                  class="paginate_drpdwn"
                >
                  <option value="5">5</option>
                  <option value="10" selected>10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
            <div class="d-flex align-items-center gap-3">
              <div>Viewing Records</div>
              <img
                src="assets/images/Icon awesome-fast-forward.svg"
                width="10"
                (click)="goToFirstPage()"
                class="text-primary reverse firstPage"
                [ngClass]="{
                  disable_icon: getCurrentPage() == true,
                  enable_icon: getCurrentPage() != true
                }"
              />
  
              <img
                src="assets/images/Icon metro-next.svg"
                (click)="goToPreviousPage()"
                class="text-primary reverse previousPage"
                [ngClass]="{
                  disable_icon: getCurrentPage() == true,
                  enable_icon: getCurrentPage() != true
                }"
              />
              <div>
                (
                <span class="value" id="lbCurrentPage"></span> -
                <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
                <span>{{ rowCount }}</span>
              </div>
              <img
                src="assets/images/Icon metro-next.svg"
                (click)="goToNexpage()"
                class="text-primary nextPage"
                [ngClass]="{
                  disable_icon: isLastPage() == true || rowCount == 0,
                  enable_icon: isLastPage() != true || rowCount > 0
                }"
              />
              <img
                src="assets/images/Icon awesome-fast-forward.svg"
                width="10"
                (click)="goToLastPage()"
                class="text-primary lastPage"
                [ngClass]="{
                  disable_icon: isLastPage() == true || rowCount == 0,
                  enable_icon: isLastPage() != true || rowCount > 0
                }"
              />
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

  </div>
  
  